import { TReturnType } from '@r1-frontend/service-engineer-visit';

import { TAgreementData } from '~/src/features/online-buy/store/actions/agreement';
import { ITariffOnlineBuy, TResultedTariff } from '~/src/features/online-buy/store/actions/setTariffs';
import { TProduct } from '~/src/features/online-buy/store/helpers/transformShopItem';

export enum EResponseStatus {
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    NOT_INITIALIZED = 'NOT_INITIALIZED',
}

export interface IImageProps {
    imgBgColor?: string,
    imageSrc?: string,
    imageAlt?: string,
    textForImage?: string,
    bgForImage?: string,
    channelCount?: number, // костыль для вывода каналов в углу картинки
    isMega?: boolean,
}

export interface TariffElementWithCostProps {
    title: string,
    imageProps: IImageProps,
    btnProps?: IButtonProps,
    priceProps?: IPriceProps,
}

export interface IPriceProps {
    price?: string,
    priceText?: string,
    isRowDirection?: boolean,
}

export interface IButtonProps {
    btnTextDesktop?: string,
    btnTextMobile?: string,
    iconNameDesktop?: string,
    iconNameMobile?: string,
    isDisabled?: boolean,
    onButtonClick?: (() => void) | null,
}

export type TPreparedEquipment = TProduct & TariffElementWithCostProps;

export interface ISelectedProducts {
    products: Record<number, ISelectedProductsItem>,
    order: number[],
    commonQuantity: number,
    instalmentQuantity: number, // количество устройств в рассрочку не более 1
}

export interface IPrice {
    cost: number,
    duration: number,
}
export interface ISelectedProductsItem {
    selectedPrice: IPrice,
    id: number,
    quantity: number,
    isInstallment: boolean,
}

export enum EStepStages {
    NOT_INITIALIZED = 'NOT_INITIALIZED',
    ORDER = 'ORDER',
    ENGINEER_VISIT = 'ENGINEER_VISIT',
    CHECK_CONNECTION = 'CHECK_CONNECTION',
    PREVIEW = 'PREVIEW',
    FINISH = 'FINISH',
}

export type TOnlineBuyData = {
    displayTariffLine: boolean,
    error: {
        isError: boolean,
        errorMessage: string,
    },

    tariffs: TResultedTariff,
    selectedProducts: ISelectedProducts,
    routers: {
        status: EResponseStatus,
        products?: Record<string, TPreparedEquipment>,
        order?: number[],
    },
    selectedTariff: ITariffOnlineBuy | null,
    agreement: TAgreementData,
    slot: TReturnType | null,
    stage: EStepStages,
    isLoading: boolean,
    isHideCallBack: boolean,
};

export const initialState: TOnlineBuyData = {
    slot: null,
    displayTariffLine: false,
    error: {
        isError: false,
        errorMessage: '',
    },
    tariffs: [],
    selectedProducts: {
        products: {},
        commonQuantity: 0,
        instalmentQuantity: 0,
        order: [],
    },
    routers: {
        status: EResponseStatus.NOT_INITIALIZED,
    },
    agreement: {
        agreementId: null,
        agreementNumber: null,
        errorMessage: '',
        hasError: false,
        isDouble: false,
    },
    selectedTariff: null,
    stage: EStepStages.NOT_INITIALIZED,
    isLoading: false,
    isHideCallBack: false,
};
